const isProd = import.meta.env.PROD

const clientId = '5acf7dea-20f2-4e91-be22-24bb5a1101da'
const scopes = 'offline_access User.Read Mail.ReadWrite Mail.ReadWrite.Shared'
const redirectUri = isProd ? 'https://tester.virtualworkforce.ai/' : 'http://localhost:9102/'

// For implicit: response_type=token
export const ms = {
    link: `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code&response_mode=query&scope=${scopes}`,
}

export function axiosWrapper(axios: Promise<any>) {
    return new Promise<any>((resolve, reject) => {
        axios.then(({ data }) => {
            resolve(data)
        }, (err) => {
            reject({
                statusCode: err.response?.status,
                data: err.response?.data || err.message || true,
            })
        })
    })
}
